/* eslint-env node */

const path = require(`path`);

const IRON_APPS_DIR = `iron/apps`;
const VOLT_APPS_INFO = require(`./volt-apps.json`);
const SPA_APPS_INFO = require(`./spa-apps.json`);
const BASE_APPS = [`common`, `design-system`];

/**
 * Volt app -> individual index.html template with asset bundles
 * Spa app  -> all points to routes/index.html and only have one bundle
 * The 2 list should be mutually exlusive. we are moving Volt app one by one to SPA_APPS
 */
const IRON_APPS_INFO = {
  ...VOLT_APPS_INFO,
  ...SPA_APPS_INFO,
};
const IRON_APPS = Object.keys(IRON_APPS_INFO);
const VOLT_APPS = Object.keys(VOLT_APPS_INFO);
const ALL_APPS = [...BASE_APPS, ...IRON_APPS];

function appDir(app) {
  return BASE_APPS.includes(app) ? path.join(`iron`, app) : path.join(IRON_APPS_DIR, app);
}

exports.IRON_APPS_INFO = IRON_APPS_INFO;
exports.VOLT_APPS = VOLT_APPS;
exports.SPA_APPS_INFO = SPA_APPS_INFO;
exports.VOLT_APPS_INFO = VOLT_APPS_INFO;
exports.IRON_APPS_DIR = IRON_APPS_DIR;
exports.ALL_APPS = ALL_APPS;
exports.appDir = appDir;
